import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// 编辑模式类型
export type EditorMode = 'standard' | 'suji' | 'crdt'

// 模式状态接口
export interface ModeState {
  // 当前编辑模式
  current: EditorMode
  // 模式切换状态
  isSwitching: boolean
  // 速记模式父笔记ID
  sujiParentNoteId: string | null
}

const initialState: ModeState = {
  current: 'crdt', // 默认模式为CRDT实时协作模式
  isSwitching: false,
  sujiParentNoteId: null
}

const modeSlice = createSlice({
  name: 'mode',
  initialState,
  reducers: {
    // 切换编辑模式
    switchMode: (state, action: PayloadAction<{ mode: EditorMode; parentNoteId?: string }>) => {
      state.isSwitching = true
      state.current = action.payload.mode
      
      // 根据模式类型设置相应配置
      if (action.payload.mode === 'suji') {
        state.sujiParentNoteId = action.payload.parentNoteId || null
      } else {
        // 标准模式
        state.sujiParentNoteId = null
      }
    },
    
    // 设置速记模式父笔记ID
    setSujiParentNoteId: (state, action: PayloadAction<string>) => {
      state.sujiParentNoteId = action.payload
    },
    
    // 清除速记模式父笔记ID
    clearSujiParentNoteId: (state) => {
      state.sujiParentNoteId = null
    },
    
    // 完成模式切换
    finishModeSwitch: (state) => {
      state.isSwitching = false
    }
  }
})

export const {
  switchMode,
  setSujiParentNoteId,
  clearSujiParentNoteId,
  finishModeSwitch
} = modeSlice.actions

export default modeSlice.reducer
